import { Button, Form } from '@/src/components/Antd';
import EditableTable from '@/src/components/EditableTable/EditableTable';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { randomNumber } from '@/src/tools/helper';
import React from 'react';
import { redirectColumns } from './config';
import css from './css.module.less';
// import { useParams } from 'react-router-dom';
// import { get } from 'lodash';
import { useSalesChannelProductLinkSet } from 'src/components/LinkModule/hooks';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const k = 'customRedirections';
const List = Form.List;

const Redirection = (props: any) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const backupRef = React.useRef<any>(null);
  const { form, isEditing, setIsEditing, currentDomain, salesChannelUuid } =
    props;

  // const p = useParams();
  // const salesChannelUuid = get(p, 'uuid');
  const linkSet = useSalesChannelProductLinkSet({ salesChannelUuid });
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      title={getI18n('salesChannelDomainAndStatus.list.customRedirection')}>
      <List name={[k]}>
        {(fields, { add, remove }) => {
          return (
            <React.Fragment>
              <EditableTable
                // id={tableId || 'SalesChannelDomainRedirectionTable' + id}
                dataSource={fields}
                id='SalesChannelDomainRedirectionTable'
                pagination={false}
                columns={redirectColumns({
                  fields,
                  isEditing,
                  remove,
                  linkSet,
                  form,
                  currentDomain,
                  salesChannelUuid,
                  getI18n,
                })}
                rowKey={'_uuid'}
                scroll={{ x: 'max-content', y: 560 }}
              />
              <div style={{ marginTop: 20 }}>
                {getI18n('salesChannelDomainAndStatus.list.use')}{' '}
                <span className={css.star}>*</span>{' '}
                {getI18n('salesChannelDomainAndStatus.list.tomatchanynumberof')}
              </div>

              {isEditing ? (
                <div className={css.btnsContainer} style={{ marginTop: 16 }}>
                  <Button
                    type='primary'
                    onClick={() => {
                      add({ _uuid: randomNumber() });
                    }}>
                    {getI18n(
                      'salesChannelDomainAndStatus.list.addNewDirection',
                    )}
                  </Button>
                  <Button
                    className={css.addBtn}
                    type='primary'
                    onClick={() => {
                      form.submit();
                    }}>
                    {getI18n('general.confirm')}
                  </Button>
                  <Button
                    className={css.addBtn}
                    onClick={() => {
                      //form.submit();
                      form.setFieldsValue({
                        [k]: backupRef.current || [],
                      });
                      backupRef.current = null;
                      setIsEditing(false);
                    }}>
                    {getI18n('general.cancel')}
                  </Button>
                </div>
              ) : (
                <div className={css.btnsContainer} style={{ marginTop: 16 }}>
                  <Button style={{ display: 'none' }}>123</Button>
                  <Button style={{ display: 'none' }}>123</Button>
                  <Button style={{ display: 'none' }}>123</Button>
                  <Button
                    type='primary'
                    onClick={() => {
                      setIsEditing(true);
                      const v = form.getFieldValue(k);
                      backupRef.current = v;
                    }}>
                    {getI18n('general.edit')}
                  </Button>{' '}
                </div>
              )}
            </React.Fragment>
          );
        }}
      </List>
    </SectionWrapper>
  );
};

export default Redirection;
